import { InactivityTimer as Component } from './InactivityTimer';

export const InactivityTimer = Component;
export default InactivityTimer;